const CURRENCY_SYMBOLS = {
	GBP : '£'
};

export const dealPackCost = (dealPack) => {
	if (!dealPack.cost ||
			!dealPack.currency) {
		return false;
	}
	if (dealPack.isFree ||
		dealPack.cost === '0') {
		return 'FREE';
	}
	const currencySymbol = (dealPack.currency in CURRENCY_SYMBOLS) ? CURRENCY_SYMBOLS[dealPack.currency] : '';
	return `${currencySymbol}${dealPack.cost}`;
};

export const dealPackDiscountCost = (dealPack) => {
	if (!dealPack.costWithDiscount ||
		!dealPack.currency) {
		return false;
	}
	if (dealPack.isFree ||
		dealPack.cost === '0') {
		return 'FREE';
	}
	const currencySymbol = (dealPack.currency in CURRENCY_SYMBOLS) ? CURRENCY_SYMBOLS[dealPack.currency] : '';
	return `${currencySymbol}${dealPack.costWithDiscount}`;
};
